import { validaIdentificacion, validaToken } from '../../Actions/Clientes/NuevoIngresoAction';
import { obtenerGnlCustomer, crearGnlCustomer, actualizarGnlCustomer } from '../../Actions/Clientes/ClientesAction';
import { listarGnlGender, listarGnlCivilStatus, listarGnlIdeType, obtenerIdTipoCIF, obtenerCamposRequeridos } from '../../Actions/Clientes/ClientPropsAction';
import { ObtenerListadoRegistrosGenericos } from '../../Actions/Utilidades/CodigosSistemaAction';
import { obtenerTokenCustomer } from '../../Actions/CIFInfo/CIFInfoAction';
import { CrearNuevoMail, ValidarRegistroEmail } from '../../Actions/Clientes/ClientesCorreosAction';
import { buscarUltimaAdmisionPendiente } from '../../Actions/Admisiones/AdmisionesAction';
import { enlistaArrayCodigosMensajesIdiomas } from '../../Actions/Generales/IdiomasAction';
import { MostrarMensaje } from '../../Utilidades/ManejoMensajes';
import { listarPaises } from '../../Actions/Generales/UbicacionAction';

export const LoadCamposrequeridos = async (companyId, typeCif, languajeCode, clientId, setListCamposRequeridos, dispatch) => {
    const responseCamposRequeridos = await obtenerCamposRequeridos(companyId, languajeCode, typeCif, clientId);
    if (responseCamposRequeridos.status === 200) //si la respuesta fue existosa
    {
        setListCamposRequeridos(responseCamposRequeridos.data);
    }
    else {
        if (responseCamposRequeridos.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseCamposRequeridos.data.errors);
            MostrarMensaje(dispatch, responseCamposRequeridos.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseCamposRequeridos.statusText]);
        }
        setListCamposRequeridos([]);
    }
};

export const existeEstudianteInfo = async (cusIde, cusTypeIdeFk, setCredenciales, dispatch) => {
    const responseExitsCliente = await validaIdentificacion(cusIde, cusTypeIdeFk);
    if (responseExitsCliente.status === 200) //si la respuesta fue existosa
    {
        setCredenciales(responseExitsCliente.data);
        window.localStorage.setItem("token_seguridad_nuevo_ingreso", responseExitsCliente.data.token);
        return { CustomerId: responseExitsCliente.data.customerId, CompanyId: responseExitsCliente.data.companyId, Language: responseExitsCliente.data.defaultLanguage };
    }
    else {
        if (responseExitsCliente.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseExitsCliente.data.errors);
            MostrarMensaje(dispatch, responseExitsCliente.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseExitsCliente.statusText]);
        }
        setCredenciales({
            companyId: '00000000-0000-0000-0000-000000000000',
            customerCIF: '',
            customerId: '00000000-0000-0000-0000-000000000000',
            defaultLanguage: "ES",
            email: '',
            imagen: null,
            imagenPerfil: null,
            nombreCompleto: '',
            state: true,
            token: '',
            userId: '00000000-0000-0000-0000-000000000000',
            username: ''
        });
        window.localStorage.setItem("token_seguridad_nuevo_ingreso", '');
        return { CustomerId: '00000000-0000-0000-0000-000000000000', CompanyId: '00000000-0000-0000-0000-000000000000', Language: 'ES' };
    }
};

export const obtenerEstudianteInfo = async (customerId, setCliente, dispatch) => {
    const responseIdentCliente = await obtenerGnlCustomer(customerId);
    if (responseIdentCliente.status === 200) //si la respuesta fue existosa
    {
        setCliente(responseIdentCliente.data);
        setCliente((anterior) => ({
            ...anterior,
            cusTypeIdeFk: responseIdentCliente.data.cusTypeIdeFk
        }));
    }
    else {
        if (responseIdentCliente.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseIdentCliente.data.errors);
            MostrarMensaje(dispatch, responseIdentCliente.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseIdentCliente.statusText]);
        }
        setCliente({
            cusCustomerId: '',
            cusIde: '',
            //cusTypeIdeFk: '',
            cusOtherIde: '',
            cusName: '',
            cusLastName1: '',
            cusLastName2: '',
            cusDateBirth: Date,
            //cusGenderFk: '',
            cusStatus: true,
            //cusCivilStatusFk: '',
            cusMail: '',
        });
    }
};

export const obtenerCifProspecto = async (setIdTipoCif, dispatch) => {
    const responseIdTipoCIF = await obtenerIdTipoCIF('S');
    if (responseIdTipoCIF.status === 200) //si la respuesta fue existosa
    {
        setIdTipoCif(responseIdTipoCIF.data);
    }
    else {
        if (responseIdTipoCIF.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseIdTipoCIF.data.errors);
            MostrarMensaje(dispatch, responseIdTipoCIF.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseIdTipoCIF.statusText]);
        }
        setIdTipoCif('00000000-0000-0000-0000-000000000000');
    }
};

export const obtenerListadoIdentificadores = async (idCompanyLoginEstudiante, setListIdentificadores, setCliente, dispatch) => {
    const responseIdent = await listarGnlIdeType(idCompanyLoginEstudiante, idCompanyLoginEstudiante);
    if (responseIdent.status === 200) //si la respuesta fue existosa
    {
        setListIdentificadores(responseIdent.data);
        if (responseIdent.data.length > 0) {
            setCliente((anterior) => ({
                ...anterior,
                cusTypeIdeFk: responseIdent.data[0].idtIdeTypeId
            }));
        }
    }
    else {
        if (responseIdent.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseIdent.data.errors);
            MostrarMensaje(dispatch, responseIdent.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseIdent.statusText]);
        }
        setListIdentificadores([]);
    }
};

export const obtenerListadoGeneros = async (idCompanyLoginEstudiante, setListGeneros, setCliente, dispatch) => {
    const responseGender = await listarGnlGender(idCompanyLoginEstudiante, idCompanyLoginEstudiante);
    if (responseGender.status === 200) //si la respuesta fue existosa
    {
        setListGeneros(responseGender.data);
        if (responseGender.data.length > 0) {
            setCliente((anterior) => ({
                ...anterior,
                cusGenderFk: responseGender.data[0].genGenderId
            }));
        }
    }
    else {
        if (responseGender.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseGender.data.errors);
            MostrarMensaje(dispatch, responseGender.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseGender.statusText]);
        }
        setListGeneros([]);
    }
};

export const obtenerListadoEstadosCiviles = async (idCompanyLoginEstudiante, setListEstadosCivil, setCliente, dispatch) => {
    const responseCivilStatus = await listarGnlCivilStatus(idCompanyLoginEstudiante, idCompanyLoginEstudiante);
    if (responseCivilStatus.status === 200) //si la respuesta fue existosa
    {
        setListEstadosCivil(responseCivilStatus.data);
        if (responseCivilStatus.data.length > 0) {
            setCliente((anterior) => ({
                ...anterior,
                cusCivilStatusFk: responseCivilStatus.data[0].cisCivilStatusId
            }));
        }
    }
    else {
        if (responseCivilStatus.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseCivilStatus.data.errors);
            MostrarMensaje(dispatch, responseCivilStatus.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseCivilStatus.statusText]);
        }
        setListEstadosCivil([]);
    }
};

export const actualizarCliente = async (objetoCliente, dispatch) => {
    actualizarGnlCustomer(objetoCliente.CusCustomerId, objetoCliente).then(response => {
        if (response.status === 200) //si la respuesta fue existosa 
        {
            MostrarMensaje(dispatch, 'success', ["updateOk"]);
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
        }
    });
};

export const insertarCliente = async (objetoCliente, dispatch) => {
     return crearGnlCustomer(objetoCliente).then(response => {
        if (response.status === 200) //si la respuesta fue existosa 
        {
            MostrarMensaje(dispatch, 'success', ["insertOk"]);
            return response.data;
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
            return '00000000-0000-0000-0000-000000000000';
        }
    });
};

export const validarToken = async (customerId, token, dispatch) => {
    return validaToken(customerId, token).then(response => {
        if (response.status === 200) //si la respuesta fue existosa 
        {
            return response.data;
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
            return false;
        }
    });
};

export const obtenerTiposGenerios = async (Codigo, Credenciales, SetTipos, dispatch) => {
    const response = await ObtenerListadoRegistrosGenericos("", Codigo, Credenciales.companyId, Credenciales.userId, '00000000-0000-0000-0000-000000000000', true);
    if (response.status === 200) //si la respuesta fue existosa
    {
        SetTipos(response.data);
        return response.data;
    }
    else {
        if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [response.statusText]);
        }
        SetTipos([]);
        return [];
    }
};

export const obtenerToken = async (customerId, companyId, dispatch) => {
   
    const objetoCliente = { CustomerId: customerId, CompanyId: companyId }

    return obtenerTokenCustomer(objetoCliente).then(response => {
        if (response.status === 200) //si la respuesta fue existosa 
        {
            MostrarMensaje(dispatch, 'success', ["SussesEmailSend"]);
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
            return '00000000-0000-0000-0000-000000000000';
        }
    });
};

export const validarEmailRegistro = async (EmailValidar, dispatch) => {
    const objetoMail = {
        CustomerId: '00000000-0000-0000-0000-000000000000',
        CustomerEmailId: '00000000-0000-0000-0000-000000000000',
        Email: EmailValidar
    }

    const responseValidarMail = await ValidarRegistroEmail(objetoMail);

    if (responseValidarMail?.status === 200) //si la respuesta fue existosa
    { return true; }
    else {
        if (responseValidarMail.data.errors) {
            //const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseValidarMail.data.errors);
            MostrarMensaje(dispatch, 'warning', ["DuplicateCustomerEmailNI"]);
        } else {
            MostrarMensaje(dispatch, 'error', [responseValidarMail.statusText]);
        }
        return false;
    }
}

export const guardarMail = async (objetoMail, dispatch) => {
    const responseCrearMail = await CrearNuevoMail(objetoMail)
    if (responseCrearMail?.status === 200) //si la respuesta fue existosa
    {
      return true;
    }
    else {
        if (responseCrearMail.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseCrearMail.data.errors);
            MostrarMensaje(dispatch, responseCrearMail.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responseCrearMail.statusText]);
        }
        return false;
    }
}

export const buscarUltAdmisionPendiente = async (objetoBuscar) => {
    const responseAdmision = await buscarUltimaAdmisionPendiente(objetoBuscar)
    if (responseAdmision?.status === 200) //si la respuesta fue existosa
    {
        return responseAdmision.data;
    }
    else {
        return null;
    }
}

export const obtenerListadoPaises = async (setListPaises, dispatch) => {
    const responsePaisesTable = await listarPaises('');
    if (responsePaisesTable.status === 200) //si la respuesta fue existosa
    {
        setListPaises(responsePaisesTable.data);
        return responsePaisesTable.data;
    }
    else {
        if (responsePaisesTable.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responsePaisesTable.data.errors);
            MostrarMensaje(dispatch, responsePaisesTable.data.typeError, arrayErrores);
        } else {
            MostrarMensaje(dispatch, 'error', [responsePaisesTable.statusText]);
        }
        setListPaises([]);
        return [];
    }
};